import { Page, Text, Image, Document, View } from '@react-pdf/renderer';
import moment from 'moment';
import {
  logoBase64,
  EXPERTISE_ACCOUNTING_ID,
  EXPERTISE_MECHANIC_ID,
  EXPERTISE_MEDICAL_ID,
  newLogoSanlamBase64,
} from 'components/DesignationLetter/constants';
import { styles } from 'components/DesignationLetter/styles';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

const DesignationLetter = (props: any): JSX.Element => {
  const renderConcernedByExpertiseType = (data: { type: string }) => {
    if (Number(data.type) === EXPERTISE_MEDICAL_ID) {
      return (
        <Text style={styles.mission}>
          Nom et prénom victime : {props.data.victim}
        </Text>
      );
    } else if (
      Number(data.type) === EXPERTISE_MECHANIC_ID ||
      Number(data.type) === EXPERTISE_ACCOUNTING_ID
    ) {
      return <></>;
    }
  };
  const renderBodyByExpertiseType = (data: { type: string }) => {
    if (Number(data.type) === EXPERTISE_MEDICAL_ID) {
      return (
        <>
          <Text style={styles.contentBody}>Cher(e) Docteur,</Text>
          <Text style={styles.contentBody}>
            Nous vous prions d’assister à l’expertise judicaire concernant la
            victime ci-haut.
          </Text>
          <Text style={styles.contentBody}>
            Veuillez agréer, Docteur, l'expression de nos salutations
            distinguées.
          </Text>
        </>
      );
    } else if (Number(data.type) === EXPERTISE_ACCOUNTING_ID) {
      return (
        <>
          <Text style={styles.contentBody}>Cher(e) Expert,</Text>
          <Text style={styles.contentBody}>
            Nous vous invitons à nous assister à l'expertise judiciaire dont
            ci-joint copie.
          </Text>
          <Text style={styles.contentBody}>
            Nous espérons avoir votre rapport d'assistance comptable dans les
            prompts brefs délais.
          </Text>
          <Text style={styles.contentBody}>
            Merci de bien vouloir y intégrer les références compagnie(notamment
            le numéro de mission) afin de permettre la prise en compte de votre
            courrier et le règlement de vos honoraires.
          </Text>
          <Text style={styles.contentBody}>
            Veuillez agréer, Monsieur, l'expression de nos salutations
            distinguées.
          </Text>
        </>
      );
    } else if (Number(data.type) === EXPERTISE_MECHANIC_ID) {
      return (
        <>
          <Text style={styles.contentBody}>Cher(e) Expert,</Text>
          <Text style={styles.contentBody}>
            Nous vous invitons à nous assister à l'expertise judiciaire dont
            ci-joint copie.
          </Text>
          <Text style={styles.contentBody}>
            Nous espérons avoir votre rapport d'assistance mécanique dans les
            prompts brefs délais.
          </Text>
          <Text style={styles.contentBody}>
            Merci de bien vouloir y intégrer les références compagnie(notamment
            le numéro de mission) afin de permettre la prise en compte de votre
            courrier et le règlement de vos honoraires.
          </Text>
          <Text style={styles.contentBody}>
            Veuillez agréer, Monsieur, l'expression de nos salutations
            distinguées.
          </Text>
        </>
      );
    }
  };
  const renderNotaByExpertiseType = (data: { type: string }) => {
    if (Number(data.type) === EXPERTISE_MEDICAL_ID) {
      return (
        <Text style={styles.nota}>
          NB: Veuillez exiger le dossier médical de la victime tout en vérifiant
          son nom exact
        </Text>
      );
    } else if (
      Number(data.type) === EXPERTISE_MECHANIC_ID ||
      Number(data.type) === EXPERTISE_ACCOUNTING_ID
    ) {
      return <Text style={styles.nota}> </Text>;
    }
  };
  const renderFooter = () => {
    if (featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)) {
      return (
        <View style={styles.newFooter}>
          <View style={styles.newFooterLeft}>
            <Text style={styles.newFooterLine1}>
              Assurance Non-Vie {'  •  '} Assurance Vie
            </Text>
            <Text style={styles.newFooterLine2}>
              <Text style={styles.newFooterBold}>SanlamAllianz Maroc</Text>
              {'  |  216, Bd Zerktouni  |  CP : 20000  |  Casablanca, Maroc'}
            </Text>
            <Text style={styles.newFooterLegal}>
              SanlamAllianz Maroc - société anonyme d’assurances et de
              réassurance au capital social de 534.187.400 de DH. Entreprise
              régie par la loi n° 17-99 portant code des assurances. RC
              Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
              355.11.249 - IF : 01084025 - ICE : 000230054000034
            </Text>
          </View>

          <View style={styles.newFooterRight}>
            <View style={styles.newFooterContactRow}>
              <Text style={styles.newFooterContactLabel}>T</Text>
              <Text>+212 522 42 06 06</Text>
            </View>
            <View style={styles.newFooterContactRow}>
              <Text style={styles.newFooterContactLabel}>F</Text>
              <Text>+212 522 20 60 81</Text>
            </View>
            <Text style={styles.newFooterWeb}>SanlamAllianz.ma</Text>
          </View>
        </View>
      );
    } else if (featureService.hasFeature(FEATURES.FUSION)) {
      return (
        <Text style={styles.footer}>
          Assurance Non-Vie | Assurance Vie | Sanlam Maroc | 216, Bd Zerktouni |
          CP: 20000 | Casablanca, Maroc Sanlam Maroc - société anonyme
          d’assurances et de réassurance au capital social de 534.187.400 de DH.
          Entreprise régie par la loi n° 17-99 portant code des assurances. RC
          Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
          355.11.249 IF : 01084025 - ICE : 000230054000034 T +212 522 42 06 06 F
          +212 522 20 60 81 sanlam.ma
        </Text>
      );
    } else {
      return (
        <Text style={styles.footer}>
          Assurance Non-Vie | Assurance Vie | Sanlam Maroc | 216, Bd Zerktouni |
          CP: 20000 | Casablanca, Maroc Sanlam Maroc - société anonyme
          d’assurances et de réassurance au capital social de 411.687.400 de DH.
          Entreprise régie par la loi n° 17-99 portant code des assurances. RC
          Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
          355.11.249 IF : 01084025 - ICE : 000230054000034 T +212 522 42 06 06 F
          +212 522 20 60 81 sanlam.ma
        </Text>
      );
    }
  };
  const dateNow = moment().format('DD/MM/YYYY');
  return (
    <Document>
      <Page style={styles.body}>
        <Image
          style={
            featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)
              ? styles.newImage
              : styles.image
          }
          src={
            featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)
              ? newLogoSanlamBase64
              : logoBase64
          }
        />
        <Text style={styles.content}>Casablanca, {dateNow}</Text>
        <Text style={styles.address}>
          {props.data?.expertInfo?.ItemDescription}
        </Text>
        <Text style={styles.address}>{props.data?.expertInfo?.address}</Text>
        <Text style={styles.address}>{props.data?.expertInfo?.expertTown}</Text>
        <Text style={styles.mission}>Pôle de gestion</Text>
        <Text style={styles.mission}>Direction automobile</Text>
        <Text style={styles.mission}>Département administratif</Text>
        <View style={styles.objectView}>
          <Text style={styles.mission}>
            Objet : Assistance à expertise {props.data?.missionType}
          </Text>
        </View>
        <Text style={styles.mission}>
          Référence Dossier : {props.data.claimNumber}
        </Text>
        <Text style={styles.mission}>
          N° de mission : {props.data?.reference}
        </Text>
        {renderConcernedByExpertiseType(props.data)}
        {renderBodyByExpertiseType(props.data)}
        <Text style={styles.manager}>Suivi Judicaire</Text>
        <Text style={styles.pj}>P.J Copie de la convocation</Text>
        {renderNotaByExpertiseType(props.data)}
        {renderFooter()}
      </Page>
    </Document>
  );
};

export default DesignationLetter;
